export default {
    timeout: 10 * 1000,
    host: 'https://d30c3b1.feishetiyu.com/',
    // host: 'https://uat-api.15a7132.com/', // uat
    webKey: 'luckygogointch-intech',
    endPoint: 'H5'
  }
